import { useRef } from 'react';
import { compareValues } from '@team/misc';

export function useObjectMemo<T>(value: T) {
  const cache = useRef<T>(value);

  if (!compareValues(cache.current, value)) {
    cache.current = value;
  }

  return cache.current;
}
